import { render, staticRenderFns } from "./scene2.vue?vue&type=template&id=33faa11c&scoped=true&"
import script from "./scene2.vue?vue&type=script&lang=ts&"
export * from "./scene2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33faa11c",
  null
  
)

export default component.exports